export default {
  landing: {
    hero: {
      tag: "Candidaturas abiertas",
      title: "Encuentre su formación en alternancia",
    },
    error: "No se ha podido cargar la página. Compruebe el enlace recibido o inténtelo de nuevo más tarde.",
    retry: "Reintentar",
    sections: {
      contact: {
        title: "Sus datos de contacto",
        first_name: "Nombre",
        last_name: "Apellido",
        email: "Correo electrónico",
        phone: "Teléfono",
        last_degree: "Último diploma obtenido",
        last_school: "Último centro de estudios",
        optional: "(opcional)",
        required_indicator: "campo obligatorio",
        required_error: "Este campo es obligatorio.",
        email_error: "La dirección de correo no es válida. Formato esperado: nombre@ejemplo.es",
      },
      training: {
        title: "Nuestras formaciones",
        more_info: "Más información",
        modal: {
          close: "Cerrar",
          brochure: "Descargar el folleto",
          select: "Elegir esta formación",
          selected: "Formación seleccionada",
        },
      },
      project: {
        preselected_note:
          "Viene por «{name}», ya seleccionada abajo. Otras formaciones cercanas también podrían interesarle.",
      },
      origin: {
        title: "¿Cómo nos conoció?",
      },
      consent: {
        aria_label: "Consentimiento",
        text: "Acepto las condiciones generales y la política de privacidad. Puedo darme de baja en cualquier momento.",
        privacy_policy_link: "política de privacidad",
        required_error: "Por favor acepte las condiciones para continuar.",
        captcha_label: "Verificación anti-robot",
      },
    },
    final: {
      info_button: "Recibir información",
      apply_button: "Presentar candidatura",
      rgpd_note: "Sus datos se tratan conforme al RGPD.",
      privacy_policy_link: "Política de privacidad",
      privacy_policy_title: "Política de privacidad",
      info_success: "¡Gracias! Le enviaremos información muy pronto.",
      info_sent_title: "¡Gracias por su interés!",
      info_sent_text:
        "Su solicitud ha sido enviada. El equipo del centro le enviará información sobre la formación que le interesa.",
      info_sent_resume_title: "¿Y si desea postularse?",
      info_sent_resume_text:
        "Acabamos de enviarle un correo a la dirección {email}. Contiene un enlace para retomar su candidatura cuando lo desee, sin tener que volver a introducir sus datos.",
      info_sent_spam_note: "¿No encuentra el correo? Revise su carpeta de correo no deseado.",
      already_registered: "Su expediente ya existe, nos pondremos en contacto si es necesario.",
    },
  },
  // TA-4768/4769: clave de nivel superior (no bajo "landing") - todas las llamadas
  // $t("candidacyGroups...") del código (CandidacyGroupsView/CandidacyFormationGroupsComponent/
  // LandingGroupRankBadgeComponent) usan esta ruta sin el prefijo "landing.".
  candidacyGroups: {
    hero: {
      tag: "Su candidatura",
      title: "Elegir un grupo",
      title_success: "¡Gracias!",
    },
    intro:
      "Ha mostrado interés por una o varias de las formaciones siguientes. Para cada una, seleccione el o los grupos a los que desea presentar su candidatura y clasifíquelos por orden de preferencia.",
    loading: "Cargando sus formaciones…",
    error: "No se han podido cargar sus formaciones. Compruebe el enlace recibido o inténtelo más tarde.",
    empty: "Ninguna formación para mostrar.",
    no_groups_title: "Ninguna candidatura abierta por el momento",
    no_groups_sub: "El CFA le informará en cuanto se abran las candidaturas para esta formación.",
    entry_year: "{year}.º año",
    start_date: "Inicio: {date}",
    rank: {
      selected: "Elección n.º{rank}",
      locked: "Grupo no seleccionable",
    },
    move_up: "Subir {name} en la clasificación",
    move_down: "Bajar {name} en la clasificación",
    max_choices_reached: "Puede seleccionar un máximo de {max} grupos.",
    validate_button: "Validar mi candidatura",
    confirm_title: "¿Validar su candidatura?",
    confirm_text:
      "Sus elecciones se transmitirán al CFA y recibirá un email para activar su cuenta. Podrá modificar su clasificación después.",
    confirm_button: "Validar",
    success: "¡Candidatura transmitida! Recibirá un email para activar su cuenta.",
    success_title: "Su expediente de candidatura ha sido creado",
    success_text:
      "Un paso más: <strong>confirme su dirección de correo</strong>. Esta verificación nos asegura que es usted y que recibirá toda la información sobre su candidatura.",
    success_box_title: "Revise sus correos ahora",
    success_step1: "Abra el correo que acabamos de enviarle.",
    success_step2: "Haga clic en el enlace de verificación: se abrirá su espacio candidato.",
    success_step3: "Complete su expediente y suba sus documentos.",
    success_note:
      "¿No encuentra el correo? Revise su carpeta de correo no deseado. Su candidatura solo se estudiará una vez completado su expediente.",
  },
  secureData: {
    hero: {
      tag: "Sus datos están seguros",
      title: "Retomar o empezar de nuevo",
    },
    intro: "Hemos conservado su solicitud. Elija cómo continuar: retome donde lo dejó o introduzca de nuevo sus datos.",
    resume_title: "Retomar donde lo dejé",
    resume_sub: "Reciba un enlace único por correo para recuperar su formulario prerrellenado.",
    restart_title: "Introducir mis datos de nuevo",
    loading: "Verificando su enlace…",
    error: "No se ha podido abrir esta página. Compruebe el enlace recibido o inténtelo más tarde.",
    mail_sent: "¡Correo enviado! Revise su bandeja de entrada para continuar.",
    resume_ok: "Hola {name}, su solicitud está lista para retomarse.",
    resume_continue: "Continuar hacia mi candidatura",
    prefill_choice: "Elija cómo continuar:",
    resume_expired: "Este enlace ha caducado o ya se ha utilizado. Solicite uno nuevo a continuación.",
    resend_link: "Recibir un nuevo enlace",
    restart_intro: "Sus nuevos datos reemplazarán los de su expediente existente.",
    restart_submit: "Confirmar mis datos",
    restart_error: "Compruebe sus datos: el correo debe ser el de su solicitud inicial.",
    restart_ok: "¡Datos actualizados!",
  },
  unsubscribe: {
    hero: {
      tag: "Dejar de recibir nuestros mensajes",
      title: "Darse de baja",
    },
    intro:
      "Puede darse de baja con un clic. Si lo desea, indíquenos el motivo a continuación — nos ayuda a mejorar nuestras comunicaciones.",
    reasons_label: "Motivo de baja",
    error: "No se ha podido abrir esta página. Compruebe el enlace recibido o inténtelo más tarde.",
    submit: "Confirmar mi baja",
    submit_error: "No se ha podido registrar su baja. Inténtelo más tarde.",
    optional_note: "Puede confirmar sin seleccionar ningún motivo.",
    done: "Anotado, ya no recibirá nuestras comunicaciones.",
    reasons: {
      admitted_elsewhere: { title: "Admitido en otro centro", sub: "Ha encontrado una formación en otro centro." },
      not_interested: { title: "Ya no me interesa", sub: "Este proyecto ya no se ajusta a su orientación." },
      not_the_requester: {
        title: "No soy el autor de la solicitud",
        sub: "Usted no inició esta solicitud de información.",
      },
      other: { title: "Otro", sub: "Otro motivo distinto de los anteriores." },
    },
  },
};
